import { addItemToSorted } from '@/core/utils/arrays';
import { useItemWorkflowTableStore } from '@/warehouse/components/ItemWorkflowTable/business';
// TODO: to delete if not used
/**
 * Adds item to **sorted** array with sorting by `id` field, specified with `idField` parameter, in **Warehouse order**,
 * namely, `desc` order.
 */
export function addItemToWhSorted(array, item, idField) {
    return addItemToSorted(array, item, idField);
}
/**
 * Adds the specified item to an {@link ItemWorkflowVirtualizedTable}.
 *
 * The list should already be **sorted** by the `id` field, specified with `idField` parameter, in **Warehouse order**,
 * namely, `desc` order.
 * Also it adjusts manually selected by warehouseman *current item index* in case if the item is added above the
 * selection, so that the selection still stands on the same item with the same id, preventing occasional
 * action mistakes.
 */
export function addItemToWorkflowTable(array, item, idField) {
    const insertedItemIndex = addItemToSorted(array, item, idField, 'desc');
    useItemWorkflowTableStore.getState().adjustCurrentItemIndex({ insertedItemIndex });
}
